import { useState } from "react";
import { postSales, postPurchase } from "../../services/orderService";
import "./PageBuySell.css";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { formatCurrencyCOP, formatNumber } from "../../helpers/FormatNumber";

export const PageBuySell = ({ sell, data, onClose }) => {
  const [units, setUnits] = useState(1);
  const [error, setError] = useState("");
  const [unitValue, setUnitValue] = useState(
    data?.fondoInfo?.valor_unidad || 0,
  );
  const [margin, setMargin] = useState(data?.fondoInfo?.negociable ? 0 : 0);
  const [vigencia, setVigencia] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  // Calcular fecha de expiración a partir de vigencia
  const expirationDate = (() => {
    if (!vigencia || isNaN(vigencia)) return "";
    const today = new Date();
    today.setDate(today.getDate() + Number(vigencia));
    return today.toISOString().split("T")[0];
  })();
  const [calculatedValues, setCalculatedValues] = useState({
    higher: 0,
    lower: 0,
  });
  const [calculatedUnitValues, setCalculatedUnitValues] = useState({
    higher: 0,
    lower: 0,
  });
  const isNuevo = !!data?.fondoInfo?.nuevo;

  const userUnits = data?.unidades || 0;
  const userAmount = data?.invested_amount || 0;

  const [totalInvestInput, setTotalInvestInput] = useState(unitValue);

  const totalInvest = isNuevo ? units * unitValue : totalInvestInput;

  const handleUnitsChange = (e) => {
    let value = parseInt(e.target.value) || 0;
    let errors = [];
    if (value < 1) {
      errors.push(
        sell
          ? "Debes vender al menos 1 unidad"
          : "Debes invertir al menos 1 unidad",
      );
    }
    if (sell && value > userUnits) {
      errors.push(
        `No puedes vender más de las ${userUnits} unidades que tienes`,
      );
    }
    if (sell && value * unitValue > userUnits * unitValue) {
      errors.push(
        `No puedes vender más de ${formatCurrencyCOP(userUnits * unitValue)}`,
      );
    }
    setError(errors.join(" y "));
    setUnits(value);
    if (!isNuevo) {
      setTotalInvestInput(value * unitValue);
    }
  };
  const handleTotalInvestChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setTotalInvestInput(value);
    let errors = [];
    if (value < unitValue) {
      errors.push("El valor mínimo es el de una unidad");
    }
    let calculatedUnits = unitValue > 0 ? Math.floor(value / unitValue) : 0;
    if (sell && calculatedUnits > userUnits) {
      errors.push(
        `No puedes vender más de las ${userUnits} unidades que tienes`,
      );
    }
    if (sell && value > userUnits * unitValue) {
      errors.push(
        `No puedes vender más de ${formatCurrencyCOP(userUnits * unitValue)}`,
      );
    }
    setError(errors.join(" y "));
    if (!isNuevo) {
      setUnits(calculatedUnits);
    }
    setCalculatedValues({ higher: 0, lower: 0 });
  };
  const handleUnitValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setUnitValue(value);
    setCalculatedUnitValues({ higher: 0, lower: 0 });
  };
  const handleMarginChange = (e) => {
    let value = parseFloat(e.target.value) || 0;
    if (value > 99) value = 99;
    setMargin(value);
    setCalculatedValues({ higher: 0, lower: 0 });
    setCalculatedUnitValues({ higher: 0, lower: 0 });
  };
  const handleVigenciaChange = (e) => {
    setVigencia(parseInt(e.target.value) || 0);
  };
  // Enviar orden al backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    setSuccess(false);
    const body = {
      units,
      price_per_unit: unitValue,
      margin: margin ? String(margin) : "0",
      seller_user: 10,
      fund: data?.fondoInfo?.id,
    };
    if (expirationDate) {
      body.expiration_date = expirationDate;
    }
    try {
      if (sell) {
        await postSales(body);
      } else {
        await postPurchase(body);
      }
      setSuccess(true);
      setTimeout(() => {
        if (onClose) onClose();
      }, 1500);
    } catch (err) {
      setError("Error al enviar la orden: " + (err.message || ""));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="w-100 container">
      <div className="d-flex justify-content-between">
        <div className="text-left">
          <p className="titleh5">Portafolio de Pablo</p>
          <p className="textCaption">
            Tienes {userUnits} unidades en este proyecto
          </p>
          <p className="textCaption">
            Equivalen a {formatCurrencyCOP(userAmount)}
          </p>
        </div>
        <div className="text-left">
          <img
            className="imgLogo"
            src={data.fondoInfo.imagen}
            alt={data.fondoInfo.name}
          />
          <p className="textProyect">
            {data.fondoInfo.name}
            <span
              style={{
                marginLeft: 8,
                padding: "2px 8px",
                borderRadius: 8,
                background: data.fondoInfo.nuevo ? "#00B8D9" : "#27AE60",
                color: "#fff",
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {data.fondoInfo.nuevo ? "Nuevo" : "En operación"}
            </span>
          </p>
          <p className="textCaption" style={{ fontWeight: 600 }}>
            {formatCurrencyCOP(data.fondoInfo.valor_unidad)} valor promedio de
            la unidad
          </p>
          <p className="textCaption">
            {formatNumber(data.fondoInfo.unidades_disponibles)} Unidades
            disponibles
          </p>
          <p className="textCaption">
            Equivalen a{" "}
            {formatCurrencyCOP(
              data.fondoInfo.unidades_disponibles * data.fondoInfo.valor_unidad,
            )}
          </p>
        </div>
      </div>
      <div className="text-left textProyect">
        <p>{sell ? "Vender" : "Comprar"}</p>
      </div>
      <form onSubmit={handleSubmit}>
        {success && (
          <div
            style={{
              color: "#155724",
              background: "#d4edda",
              border: "1px solid #c3e6cb",
              borderRadius: 6,
              padding: "8px 12px",
              fontWeight: 600,
              textAlign: "center",
              margin: "16px auto 0 auto",
              maxWidth: 350,
            }}
          >
            ¡Orden enviada con éxito!
          </div>
        )}
        {isNuevo ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 320,
              marginBottom: 10,
            }}
          >
            <div
              style={{
                minWidth: 340,
                maxWidth: 400,
                width: "100%",
                textAlign: "center",
                position: "relative",
              }}
            >
              <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-units">
                  {sell ? "Unidades a vender" : "Unidades a comprar"}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-units"
                  type="number"
                  value={units}
                  onChange={handleUnitsChange}
                  label={sell ? "Unidades a vender" : "Unidades a comprar"}
                  inputProps={{
                    min: 1,
                    step: 1,
                    max: sell ? userUnits : undefined,
                  }}
                  endAdornment={
                    <InputAdornment position="end">unidades</InputAdornment>
                  }
                  sx={{ fontSize: 20, fontWeight: 600, background: "#f7fafd" }}
                />
              </FormControl>
              <div style={{ marginTop: 24, marginBottom: 8 }}>
                <span style={{ fontSize: 15, color: "#888" }}>
                  Total a invertir
                </span>
                <div
                  style={{
                    fontWeight: 700,
                    color: "#00B8D9",
                    fontSize: 28,
                    marginTop: 2,
                  }}
                >
                  {formatCurrencyCOP(totalInvest)}
                </div>
              </div>
              <div
                style={{
                  fontSize: 14,
                  color: "#27AE60",
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                Valor de cada unidad: {formatCurrencyCOP(unitValue)}
              </div>
              {/* Mensaje de error antes del botón */}
              {error && (
                <div
                  style={{
                    color: "#856404",
                    background: "#fff3cd",
                    border: "1px solid #ffeeba",
                    borderRadius: 6,
                    padding: "8px 12px",
                    fontWeight: 600,
                    textAlign: "center",
                    margin: "16px auto 0 auto",
                    maxWidth: 350,
                  }}
                >
                  {error}
                </div>
              )}
              <div style={{ marginTop: 32 }}>
                <button
                  type="submit"
                  className="btnSell sell"
                  style={{
                    width: "100%",
                    fontSize: 18,
                    padding: "12px 0",
                    borderRadius: 8,
                  }}
                  disabled={loading || !!error || units < 1 || (sell && units > userUnits)}
                >
                  {loading ? "Cargando..." : (sell ? "Vender" : "Comprar")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 16,
                justifyContent: "center",
              }}
            >
              <FormControl sx={{ m: 1, width: "45%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-total-invest">
                  Total a invertir
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-total-invest"
                  type="number"
                  value={totalInvestInput}
                  onChange={handleTotalInvestChange}
                  label="Total a invertir"
                  sx={{ fontSize: 18, background: "#f7fafd" }}
                  inputProps={{ min: unitValue, step: unitValue }}
                />
                <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
                  {totalInvestInput > 0
                    ? `Has ingresado: ${formatCurrencyCOP(totalInvestInput)}`
                    : "Ingresa el valor a invertir"}
                </div>
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-units">
                  {sell ? "Unidades a vender" : "Unidades a comprar"}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-units"
                  type="number"
                  value={units}
                  onChange={handleUnitsChange}
                  label={sell ? "Unidades a vender" : "Unidades a comprar"}
                  inputProps={{
                    min: 1,
                    step: 1,
                    max: sell ? userUnits : undefined,
                  }}
                  endAdornment={
                    <InputAdornment position="end">unidades</InputAdornment>
                  }
                  sx={{ fontSize: 18, background: "#f7fafd" }}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-unit-value">
                  Valor de unidad
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-unit-value"
                  type="number"
                  value={unitValue}
                  label="Valor de unidad"
                  disabled
                  sx={{ fontSize: 18, background: "#f7fafd" }}
                />
                <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
                  {unitValue > 0
                    ? `Has ingresado: ${formatCurrencyCOP(unitValue)}`
                    : "Ingresa el valor de la unidad"}
                </div>
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-margin">
                  Margen de negociación
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-margin"
                  type="number"
                  value={margin}
                  onChange={handleMarginChange}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="Margen de negociación"
                  sx={{ fontSize: 18, background: "#f7fafd" }}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-vigencia" shrink>
                  Fecha de expiración
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-vigencia"
                  type="date"
                  value={expirationDate}
                  onChange={e => {
                    // Al cambiar la fecha, recalcula vigencia
                    const selected = new Date(e.target.value);
                    const today = new Date();
                    const diff = Math.ceil((selected - today) / (1000 * 60 * 60 * 24));
                    setVigencia(diff > 0 ? diff : 0);
                  }}
                  label="Fecha de expiración"
                  sx={{ fontSize: 18, background: "#f7fafd" }}
                />
                <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
                  {expirationDate
                    ? `Vigencia: ${formatNumber(vigencia)} días`
                    : "Selecciona la fecha de expiración"}
                </div>
              </FormControl>
            </div>
            <div
              style={{
                marginTop: 24,
                background: "#f7fafd",
                border: "1.5px solid #00B8D9",
                borderRadius: 10,
                padding: 10,
                maxWidth: 600,
                marginLeft: "auto",
                marginRight: "auto",
                boxShadow: "0 2px 8px 0 rgba(0,184,217,0.08)",
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 17,
                  marginBottom: 8,
                  color: "#00B8D9",
                }}
              >
                Simulación según margen de negociación
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 16,
                  flexWrap: "wrap",
                  marginBottom: 8,
                }}
              >
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div style={{ fontWeight: 600, color: "#27AE60" }}>
                    Margen -{margin || 0}%
                  </div>
                  <div style={{ fontSize: 15 }}>
                    Valor unidad:{" "}
                    <span style={{ fontWeight: 600 }}>
                      {formatCurrencyCOP(
                        totalInvest * (1 - (Math.abs(margin) || 0) / 100),
                      )}
                    </span>
                  </div>
                  <div style={{ fontSize: 15 }}>
                    Unidades posibles:{" "}
                    <span style={{ fontWeight: 600 }}>
                      {(() => {
                        const simulatedUnitValue =
                          totalInvest * (1 - (Math.abs(margin) || 0) / 100);
                        if (simulatedUnitValue < unitValue) return 0;
                        return Math.floor(simulatedUnitValue / unitValue);
                      })()}
                    </span>
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div style={{ fontWeight: 600, color: "#E67E22" }}>
                    Margen +{margin || 0}%
                  </div>
                  <div style={{ fontSize: 15 }}>
                    Valor unidad:{" "}
                    <span style={{ fontWeight: 600 }}>
                      {formatCurrencyCOP(
                        totalInvest * (1 + (Math.abs(margin) || 0) / 100),
                      )}
                    </span>
                  </div>
                  <div style={{ fontSize: 15 }}>
                    Unidades posibles:{" "}
                    <span style={{ fontWeight: 600 }}>
                      {(() => {
                        const simulatedUnitValue =
                          totalInvest * (1 + (Math.abs(margin) || 0) / 100);
                        if (simulatedUnitValue < unitValue) return 0;
                        return Math.floor(simulatedUnitValue / unitValue);
                      })()}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ fontSize: 13, color: "#888", marginTop: 10 }}>
                Este cálculo es solo informativo y depende del margen de
                negociación definido.
              </div>
            </div>
            {error && (
              <div
                style={{
                  color: "#856404",
                  background: "#fff3cd",
                  border: "1px solid #ffeeba",
                  borderRadius: 6,
                  padding: "8px 12px",
                  fontWeight: 600,
                  textAlign: "center",
                  margin: "16px auto 0 auto",
                  maxWidth: 350,
                }}
              >
                {error}
              </div>
            )}
            <div style={{ marginTop: 32 }}>
              <button
                type="submit"
                className="btnSell sell"
                style={{
                  width: "100%",
                  fontSize: 18,
                  padding: "12px 0",
                  borderRadius: 8,
                }}
                disabled={loading || units < 1 || (sell && units > userUnits)}
              >
                {loading ? "Cargando..." : (sell ? "Vender" : "Comprar")}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};
